module.exports = __webpack_public_path__ + "img/select_icon.0697dbd6.svg";